import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import queryString from 'querystring';
import If from '../If/If';
import { isNullOrUndefined } from 'Util/TypeGuards';
import { getContactUsEmailAddress } from 'Services/Api/_HumanWritten/EmailTemplateEntityService';
import { themeStore } from 'Models/ThemeStore';
import { SERVER_URL } from 'Constants';
import Card from 'Views/Components/_HumanWritten/Card/Card';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';

export function InvalidToken() {
	const location = useLocation();
	const queryParams = location.search.substring(1);
	const params = queryString.parse(queryParams);
	const error = params.error?.toString() ?? '';
	const [contactUsEmailAddress, setContactUsEmailAddress] = useState('');

	useEffect(() => {
		getContactUsEmailAddress().then(x => {
			setContactUsEmailAddress(x);
		});
	}, []);

	return (
		<>
			<NavigationWrapper />
			<div className="body-content error-page">
				<div
					className="error-page__background"
					style={{
						backgroundImage: `url(${themeStore.errorPageBackgroundImageURL})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				/>
				<div className="error-page__content">
					<Card>
						<h5>Whoops</h5>
						<If condition={error === 'invalid-token' || !error}>
							<p className="body--content">
								<strong>Your link has expired or is invalid</strong>
								<br />
								Please try changing your email address again by logging in with your{' '}
								<strong>original email address</strong>.
							</p>
						</If>
						<If condition={error === 'used-token'}>
							<p className="body--content">
								<strong>Your email address has already been changed</strong>
								<br />
								Please try logging in with your <strong>new email address</strong>.
							</p>
						</If>
						<If condition={error === 'cancelled-token'}>
							<p className="body--content">
								<strong>The request to change your email address has been cancelled</strong>
								<br />
								Please log into your account using your <strong>original email address</strong> and
								change your email address again.
							</p>
						</If>
						<p className="body--content">
							If this error persists,
							<If condition={!!(window as any).Intercom}>
								{' '}
								<span
									style={{
										color: 'var(--colour-brand-primary)',
										textDecoration: 'underline',
										cursor: 'pointer',
									}}
									onKeyDown={() => {
										(window as any).Intercom('show');
									}}
									role="button"
									tabIndex={0}
									onClick={() => {
										(window as any).Intercom('show');
									}}
								>
									message us through live chat
								</span>
								.
							</If>
							<If condition={isNullOrUndefined((window as any).Intercom)}>
								{' '}
								email us at{' '}
								<a
									href={`mailto:${contactUsEmailAddress}`}
									style={{ color: 'var(--colour-brand-primary)' }}
								>
									{contactUsEmailAddress}
								</a>{' '}
								and we will assist you further.
							</If>
						</p>
						<Button
							display={Display.Solid}
							colors={Colors.Primary}
							newStyles
							onClick={() => {
								document.location.assign(`${SERVER_URL}/home`);
							}}
						>
							Go to home page
						</Button>
					</Card>
				</div>
			</div>
		</>
	);
}
